exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panels--3KGvITa6rwHxkwqFhf1et4 {\n  margin: 0 0 1.5rem 0;\n}\n", ""]);

// exports
exports.locals = {
	"specialtyFilterContainer": "panels--3KGvITa6rwHxkwqFhf1et4",
	"specialtyFilterContainer": "panels--3KGvITa6rwHxkwqFhf1et4"
};